import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import theme from '../../muiTheme';
import titleCaseFromCamel from '../../utils/titleCase';

/**
 * Component for displaying a teachers qualifications.
 *
 * @component Limited Text Field
 * @param {object} props props
 * @param {string} props.label
 * @param {string} props.error
 * @param {string} props.value
 * @param {integer} props.textLength
 * @param {string} props.width
 * @param {boolean} props.disabled
 * @param {function} props.updateField
 *
 * @return (
 * <Qualifications />
 * )
 */

const LimitedTextField = props => {
    return (
        <Box>
            <TextField
                data-cy={
                    props.hasOwnProperty('data-cy') ? props['data-cy'] : ''
                }
                disabled={props.disabled}
                label={titleCaseFromCamel(props.label)}
                id={props.id || props.label}
                error={props.error}
                helperText={props.errorText}
                value={props.value}
                multiline
                rows={4}
                onChange={props.updateField}
                sx={{
                    width: props.width,
                    marginTop: theme.spacing(2),
                }}
                margin="normal"
                variant="outlined"
                inputProps={{ maxLength: props.textLength }}
            />

            <Box sx={{ textAlign: 'right', width: props.width }}>
                {typeof props.value !== 'undefined' && (
                    <Typography variant="body2">{`${props.value.length} / ${props.textLength}`}</Typography>
                )}
            </Box>
        </Box>
    );
};

export default LimitedTextField;
